import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'
import VueMatchHeights from 'vue-match-heights';
import VueTextareaAutosize from 'vue-textarea-autosize'
// import "vue-material-design-icons/styles.css"
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
window.$ = require('jquery')
window.JQuery = require('jquery')
import Toasted from 'vue-toasted';

const firebase = require("firebase/app");
import 'firebase/app'
import 'firebase/auth'

Vue.config.productionTip = false
var config = {
    apiKey: "AIzaSyAQoztk_w1rdtwgqmZgDZnUToRDK0vYyHY",
    authDomain: "ellis-audio-webapp.firebaseapp.com",
    databaseURL: "https://ellis-audio-webapp.firebaseio.com",
    projectId: "ellis-audio-webapp",
    storageBucket: "ellis-audio-webapp.appspot.com",
    messagingSenderId: "116020144636",
    appId: "1:116020144636:web:f1db42cad08eaf30"
  };


firebase.initializeApp(config)

// import ea_hire_packages from './components/ea-hire-packages.vue'
const ea_hire_packages = () => import("./components/ea-hire-packages.vue");
// import ea_hire_package_products from './components/ea-hire-package-products.vue'
const ea_hire_package_products = () => import("./components/ea-hire-package-products.vue");
// import ea_hire_products from './components/ea-hire-products.vue'
const ea_hire_products = () => import("./components/ea-hire-products.vue");
// import ea_sales_products from './components/ea-sales-products.vue'
const ea_sales_products = () => import("./components/ea-sales-products.vue");
// import ea_gallery from './components/ea-gallery.vue'
const ea_gallery = () => import("./components/ea-gallery.vue");
// import ea_about from './components/ea-about.vue'
const ea_about = () => import("./components/ea-about.vue");
// import ea_TsandCs from './components/ea-tsandcs.vue'
const ea_TsandCs = () => import("./components/ea-tsandcs.vue");
// import ea_login from './components/ea-login.vue'
const ea_login = () => import("./components/ea-login.vue");
// import ea_logout from './components/ea-logout.vue'
const ea_logout = () => import("./components/ea-logout.vue");

//Admin
// import ea_login from './components/ea-login.vue'
// import ea_admin_hire_packages from './components/ea-admin-hire-packages.vue'
const ea_admin_hire_packages = () => import("./components/ea-admin-hire-packages.vue");
// import ea_admin_hire_package_products from './components/ea-admin-hire-package-products.vue'
// import ea_admin_hire_products from './components/ea-admin-hire-products.vue'
const ea_admin_hire_products = () => import("./components/ea-admin-hire-products.vue");
// import ea_admin_sales_products from './components/ea-admin-sales-products.vue'
const ea_admin_sales_products = () => import("./components/ea-admin-sales-products.vue");
// import ea_admin_gallery from './components/ea-admin-gallery.vue'
const ea_admin_gallery = () => import("./components/ea-admin-gallery.vue");

Vue.use(VueRouter)
Vue.use(VueLazyload)
Vue.use(VueMatchHeights, {
  disabled: [768], // Optional: default viewports widths to disabled resizing on. Can be overridden per usage
});
Vue.use(VueTextareaAutosize)
Vue.use(BootstrapVue)
Vue.use(Toasted, {
    iconPack : 'material' // set your iconPack, defaults to material. material|fontawesome|custom-class
})

Vue.toasted.register('toast_error', (payload) => {
		
        // if there is no message passed show default message
        if(! payload.message) {
			return "Oops.. Something Went Wrong.."
        }
		
        // if there is a message show it with the message
        return "Oops.. " + payload.message;
    }, {
    type : 'error',
    icon : 'error_outline',
    duration: 3000,
})

Vue.toasted.register('toast_success', (payload) => {
		
        // if there is no message passed show default message
        if(! payload) {
			return "Success!"
        }
		
        // if there is a message show it with the message
        return payload;
    }, {
    type : 'success',
    icon : 'thumb_up',
    duration: 3000,
    action : [
        {
            text : 'Close',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
            }
        },
    ]
})

const routes = [
	{path: '/', redirect: '/packages'},
	{path: '/packages/', name: 'packages', component: ea_hire_packages},
  {path: '/package/:package', component: ea_hire_package_products},
	{path: '/products/', name: 'products', component: ea_hire_products},
	{path: '/products/:filter', component: ea_hire_products},
	{path: '/sales/', name: 'sales', component: ea_sales_products},
	{path: '/gallery/', name: 'gallery', component: ea_gallery},
	{path: '/about/', name: 'about', component: ea_about},
	{path: '/ts&cs/', name: 'ts&cs', component: ea_TsandCs},
	{path: '/login/', name: 'login', component: ea_login},
  {path: '/logout/', name: 'logout', component: ea_logout},
	// {path: '/admin/', name: 'admin', component: ea_admin_hire_packages, meta: { requiresAuth: true },
	// 	children:[
	{path: '/admin/packages', name: 'admin packages', component: ea_admin_hire_packages, meta:{protected:true}},
  {path: '/admin/package/:package', component: ea_hire_package_products},
	{path: '/admin/products', name: 'admin products', component: ea_admin_hire_products, meta:{protected:true}},
	{path: '/admin/sales', name: 'admin sales', component: ea_admin_sales_products, meta:{protected:true}},
	{path: '/admin/gallery', name: 'admin gallery', component: ea_admin_gallery, meta:{protected:true}},
		// ]},
	{path: '*', redirect: '/packages'},
]

const router = new VueRouter({
	routes,
	mode: 'history'
})

router.beforeEach((to, from, next) => {
	// console.log(to.fullPath)
	// console.log(this)
	// this.isAdminPage = false
	// this.path = to.fullPath
  // if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!to.meta.protected) {
      next()
    } else {
      firebase.auth().onAuthStateChanged((user)=>{
        if(user && user.email == 'nick@ellisaudio.com.au') {
          next()
        } else {
          router.push({
            path: '/login',
            query:{
              redirect: to.fullPath
            }
          })
        }
      })
    }
  })

let app

firebase.auth().onAuthStateChanged(()=>{
  if(!app)
  {
    app = new Vue({
      el: '#app',
      router,
      render: h => h(App)
    })
  }
})

